import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Wrapper = styled.div<{start?:boolean, background:string}>`
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background:${props => props.background};
    z-index: 1000;
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out, background 0.5s ease-in-out;
    transform: scale(${props => props.start?"1":"0"});
    opacity: ${props => props.start?"1":"0"};
    padding:50px 30px 30px 30px;

`; 

export const SplashCentent = styled.div`
    background:#fff; 
    padding:20px;
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.25);
    font-size: 16px;
    border-radius: 5px;
    font-weight: 500;
`; 

export const NavContainer = styled.div`
    position: absolute;
    top:30px;
    left:30px;
    height:24px;
    display:flex;
    align-items: center;
    gap:20px;

    svg{
        height:100%;
        path{
            fill:#fff;
        }
    }
`; 

export const CloseButton = styled.button`
    position: absolute;
    top:30px;
    right:30px;
    width:10vw;
    max-width: 24px;
    
    svg{
        width:100%;
        path{
            fill:#fff;
        }
    }
`; 

export const Container = styled.div`
    width:100%;
    max-width: 600px;
    height:100%;
    margin:0 auto;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`; 

export const TopText = styled.div`
    color:#fff;
    font-size: 24px;
    font-weight: 600;
    padding:50px; 
    text-align: center;

    ${mq(Devices.mobile)}{
        padding:6vw 2vw;
        font-size: 5.5vw;
        min-height:10vh;
    }
`; 

export const BottomText = styled.div`
    color:#fff;
    font-size: 30px;
    padding:20px;
    text-align: center;
    display:flex;
    flex-direction: column;
    align-items: center;
    width: 80%;

    ${mq(Devices.mobile)}{
        padding:6vw 2vw;
        font-size: 5vw;
    }
`; 

export const MiddleContainer = styled.div`
    background:#fff;
    border-radius:30px;
    overflow:hidden;
    width:100%;
    max-width: 400px;
    display:flex;
    flex-direction: column;
    align-items: center;
    padding:20px;


    svg{
        width:30%;
    }

    p{
        font-size: 22px;
        font-weight: 600;
        margin-top: 10px; 
        text-align: center;
        padding:0 10px;
    }
    span{
        font-size: 18px;
    }

    ${mq(Devices.mobile)}{
        svg{
            width:30%;
        }

        p{
            font-size: 5vw;
            font-weight: 600;
            margin-top: 10px;
        }
        span{
            font-size: 5.5vw;
        }
    }
`;

export const LottieContent = styled.div`
    width:80%;
    margin-top: -20%;
`;

export const QRContainer = styled.div`
    border-radius: 30px;
    overflow: hidden;
    width:100%;
    max-width: 400px;
    aspect-ratio: 1 / 1.3;
    background:#fff;
    position: relative;
    

    > section > div{
        position: unset !important;
    }
    
`;

export const CodeContainer = styled.div`
    width:100%;
    max-width: 400px;
    position: relative;

`;

export const QRContainerBorder = styled.div`
    position: absolute;
    top:0; 
    left:0;
    bottom:0;
    right:0;
    border:20px solid #fa505e86;
    z-index: 10;
    border-radius: 30px;
    
`;


export const ModalContainer = styled.div`
    background:#fff;
    box-shadow: 0 0 8px rgba(0,0,0,0.25);
    padding:14px 20px;
    border-radius: 5px;
    min-width:240px;
    max-width:340px;

    span{
        font-size: 20px;
        font-weight: 500;
    }
    p{
        font-size: 14px;
        margin-bottom: 16px;
    }

    button{
        width:47%;
        color:#fff;
        font-size: 14px;
        padding:6px 0;
        border-radius: 4px;
        opacity: 0.8;

        :nth-of-type(1){
            background:#FA505E;
            margin-right: 6%;
        }
        :nth-of-type(2){
            background:#338993;
        }

        :hover{
            opacity: 1;
        }
    }
`;